import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'edportal-tos',
  templateUrl: './tos.component.html',
  styles: ``,
})
export class TosComponent {
  constructor(private readonly router: Router) {}

  agree() {
    this.router.navigateByUrl('/launch/account');
  }
}
